export const EContentBlockType = {
  HEADING_TEXT: "case-blocks.heading-text",
  STATS: "case-blocks.stats",
  HEADLINES_AND_BULLETS: "case-blocks.headlines-and-bullets",
  FEATURED_BULLETS: "case-blocks.featured-bullets",
  IMAGE_GALLERY: "case-blocks.image-gallery",
  TEXT_AND_IMAGE: "case-blocks.text-and-image",
  TESTIMONIAL: "case-blocks.testimonial",
  METRICS: "case-blocks.metrics",
} as const;

export enum EServiceName {
  EVENT_MARKETING = "event-marketing",
  SPORT_MARKETING = "sport-marketing",
  CONSUMER_PROMO = "consumer-promotion",
}
